import { render } from "./BCardTitle.vue?vue&type=template&id=447db45e&ts=true"
import script from "./BCardTitle.vue?vue&type=script&lang=ts"
export * from "./BCardTitle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__